import React, { useEffect } from "react"
import FooterComponent from "../../components/footer"
import ReactHelmet from "src/components/react-helmet"

const LeaseDetailsForm = () => {
  useEffect(() => {
    try {
      var script = document.createElement("script")
      script.src = "https://paperform.co/__embed"
      script.async = true
      document.body.appendChild(script)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <>
      <ReactHelmet
        url="lease-details"
        title={`Lease Details`}
        description="Tolobi - Rental Made Easy"
      />
      <div data-paperform-id="tolobi-lease-details"></div>
      <FooterComponent />
    </>
  )
}

export default LeaseDetailsForm
